// Xóa ID confirm (client 2026-10-02 "cái xóa ID chưa xóa được"): the iPhone keyboard capitalises the first letter, so
// "Huykr99" typed for the account huykr99 left the button off and nothing was sent. Usernames ignore upper/lower case
// (backend lib/ten_dang_nhap.js); the account deleted is the one of the row, the typed name only confirms it.
export function khopTenXoa(typed: string, name: string | null | undefined): boolean {
  const t = typed.trim().toLowerCase();
  return !!name && t !== '' && t === name.trim().toLowerCase();
}
